export const GET_CONSTROL_USERS_REQUEST = 'GET_CONSTROL_USERS_REQUEST';
export const GET_CONSTROL_USERS_SUCCESS = 'GET_CONSTROL_USERS_SUCCESS';
export const GET_CONSTROL_USERS_FAILED = 'GET_CONSTROL_USERS_FAILED';

export const PUT_CONTROL_STATUS = 'PUT_CONTROL_STATUS';
